import React, { useContext, useEffect, useState } from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { login, MAGIC_LINK } from '../resources/auth';

const LoginByMagicLink = () => {
  const history = useHistory();
  const { magicLinkId } = useParams();
  const [ error, setError ] = useState('');
  const { t } = useTranslation();
  useEffect(() => {
    setError('');
    login(magicLinkId, '', MAGIC_LINK)
      .then(() => {
        history.push('/parking-locations');
      })
      .catch(() => setError('error.generic'));
  }, []);

  return (<>{error && <Alert type="error" size="large" message={t(error)}/>}</>);
};

export default LoginByMagicLink;
